import { useResource } from "hooks/useResource";
import { getManagement } from "services/content";
import { useSetPage } from "lib/nav";
import SectionLabel from "components/shared/SectionLabel";
import MgmtCard from "components/shared/MgmtCard";
import Reveal from "components/shared/Reveal";
import Skeleton from "components/shared/Skeleton";

export default function ManagementPreview() {
  const setPage = useSetPage();
  const { data: people } = useResource(getManagement);

  return (
    <section className="px-4 sm:px-10 py-[68px] bg-cream">
      <div className="max-w-container mx-auto">
        <div className="flex justify-between items-end mb-10 gap-4">
          <div>
            <SectionLabel color="#005C40" label="Our Leadership" />
            <h2 className="font-serif text-[28px] sm:text-[38px] font-bold text-green-dark">
              Management
            </h2>
          </div>
          <button
            onClick={() => setPage("about")}
            className="bg-transparent text-green border-[1.5px] border-green rounded-lg px-[22px] py-2.5 font-sans font-semibold text-[13px] cursor-pointer whitespace-nowrap transition-colors hover:bg-green-light"
          >
            Meet All →
          </button>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[18px]">
          {!people
            ? Array.from({ length: 6 }).map((_, i) => (
                <Skeleton key={i} className="h-[210px] rounded-[14px]" />
              ))
            : people.map((p, i) => (
                <Reveal key={p.name} delay={(i % 3) * 90}>
                  <MgmtCard person={p} />
                </Reveal>
              ))}
        </div>
      </div>
    </section>
  );
}
